import { computed } from 'vue';
import useSize from '~/modules/size/composables/useSize';
import type { Size } from '~/declaration/traits';

export const useGiftConsolidated = () => {
  const { selectedSizeId, sizes } = useSize();

  const selectedGift = computed({
    get() {
      return selectedSizeId.value;
    },
    set(value: number | null) {
      selectedSizeId.value = value;
    },
  });

  const giftOptions = computed(() => sizes.value.map((size: Size) => ({ id: size.id.toString(), text: size.displayName })));

  return {
    selectedGift,
    giftOptions,
  };
};
